import { Row, Col, Card } from "react-bootstrap"
import Dropzone from "react-dropzone"
import useFileUploader from "./useFileUploader"
import ConditionalView from "components/ConditionalView"
import { useState } from "react"
import ImagePreview from "./ImagePreview"

export type FileType = File & {
  url?: string
  key?: string
  formattedSize?: string
}

type FileUploaderProps = {
  onFileUpload?: (files: FileType) => void
  hideUploaded?: boolean
  file_url?: string
  styles?: object
  multiple?: boolean
  clearDefaultImage?: any
}

const FileUploader = ({
  onFileUpload,
  clearDefaultImage,
  file_url,
  multiple,
  hideUploaded,
  styles,
}: FileUploaderProps) => {
  const [showPreview, setShowPreview] = useState(false)
  const { selectedFile, handleAcceptedFile, removeFile } = useFileUploader()

  return (
    <>
      {((!file_url && !selectedFile) || hideUploaded) && (
        <Dropzone
          onDrop={async (acceptedFiles) => {
            if (acceptedFiles.length < 2)
              return handleAcceptedFile(acceptedFiles[0], onFileUpload)

            // const files = Array.prototype.slice.call(acceptedFiles)
            const data = await Promise.all(
              acceptedFiles.map((file: any) => handleAcceptedFile(file))
            )

            onFileUpload && onFileUpload(data as any)
          }}
          maxFiles={multiple ? 0 : 1}
        >
          {({ getRootProps, getInputProps }) => (
            <div className="dropzone" style={styles}>
              <div className="dz-message needsclick" {...getRootProps()}>
                <input {...getInputProps()} multiple={multiple} />
                <i className="h3 text-muted dripicons-cloud-upload" />
                <h5 className="text-gray-500 !font-medium">
                  Drop file here or click to upload.
                </h5>
              </div>
            </div>
          )}
        </Dropzone>
      )}

      {(file_url || selectedFile) && !hideUploaded && (
        <div className="dropzone-previews" id="uploadPreviewTemplate">
          <Card className="mb-2 shadow-none border">
            <div className="p-2" onClick={(e: any) => e.stopPropagation()}>
              <div className="grid">
                <div className="grid">
                  <ConditionalView
                    condition={
                      !!(selectedFile?.url || file_url)?.endsWith(".pdf")
                    }
                  >
                    <div className="w-12 h-12 grid place-items-center bg-primary-bg  rounded-full">
                      <i className="ri-article-fill ri-2x"></i>
                    </div>
                    <div
                      onClick={(e: any) => {
                        e.stopPropagation()
                        setShowPreview(!showPreview)
                      }}
                    >
                      <img
                        data-dz-thumbnail=""
                        className="avatar-sm rounded-md bg-slate-200 min-w-[100%] min-h-[220px] object-contain "
                        // className='avatar-sm rounded bg-light w-full h-auto object-contain '
                        alt={selectedFile?.name || file_url?.split("/")?.at(-1)}
                        src={selectedFile?.url || file_url}
                      />
                    </div>
                  </ConditionalView>
                </div>
                <Col>
                  <a
                    href={selectedFile?.url || file_url}
                    target="_blank"
                    className="text-muted fw-bold"
                  >
                    {selectedFile?.key || file_url?.split("/")?.at(-1)}
                  </a>
                  <p className="mb-0">
                    <strong>{selectedFile?.formattedSize}</strong>
                  </p>
                </Col>
                <div className="flex absolute right-4 top-4 justify-center items-center rounded-full overflow-clip cursor-pointer bg-white w-[28px] h-[28px]">
                  <i
                    className="dripicons-cross text-[22px] mb-[2px]"
                    onClick={() => {
                      removeFile?.()
                      clearDefaultImage?.()
                    }}
                  />
                </div>
              </div>
            </div>
          </Card>
          <ConditionalView condition={showPreview}>
            <ImagePreview
              url={selectedFile?.url || file_url}
              onClose={() => setShowPreview(false)}
            />
          </ConditionalView>
        </div>
      )}
    </>
  )
}

export { FileUploader }
